import { render, staticRenderFns } from "./revealScope.vue?vue&type=template&id=1842efa7"
import script from "./revealScope.vue?vue&type=script&lang=js"
export * from "./revealScope.vue?vue&type=script&lang=js"
import style0 from "./revealScope.vue?vue&type=style&index=0&id=1842efa7&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1842efa7')) {
      api.createRecord('1842efa7', component.options)
    } else {
      api.reload('1842efa7', component.options)
    }
    module.hot.accept("./revealScope.vue?vue&type=template&id=1842efa7", function () {
      api.rerender('1842efa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealScope.vue"
export default component.exports